module.exports = __webpack_public_path__ + "static/img/Frame_4108@2x(4).9173bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4108@2x(4).png
// module id = zA89
// module chunks = 59